<template>
  <v-container class="pa-5 watchlist-container" fluid>
    <h1 class="ml-4 mb-6">{{ $t("watchlist") }}</h1>
    <v-spacer />

    <v-row class="d-flex justify-space-between" style="padding-right: 20px">
      <h3 class="mt-3 mb-3 ml-4">
        {{ $t("watchlistBrokerAccounts", { watchlist: $t("watchlist") }) }}
      </h3>
      <div class="legend-component">
        <div class="legend-container">
          <v-col class="d-flex icons-container">
            <img
              src="@/assets/icons/noAudited.svg"
              alt="No Audited Icon"
              class="mr-2"
              style="width: 16px; height: 16px; margin: 0 !important; margin-top: -2px;"
            /><p class="label mr-3 ml-1">No {{ $t("verified") }}</p>
            <img
              src="@/assets/icons/Audited.svg"
              alt="No Audited Icon"
              class="mr-2"
              style="width: 16px; height: 16px; margin: 0 !important; margin-top: -2px;"
            />
            <p class="label mr-3 ml-1">{{ $t("verified") }}</p>
            <img
              src="@/assets/icons/noauto-sync.svg"
              alt="Audited Icon"
              class="mr-2"
              style="
                width: 15px;
                height: 15px;
                color: gray;
                margin: 0 !important;
              "
            /><p class="label mr-3 ml-1">No {{ $t("automated") }}</p>
            <img
              src="@/assets/icons/AutoSync.svg"
              alt="AutoSync Icon"
              class="mr-2"
              style="
                width: 15px;
                height: 15px;
                color: green;
                margin: 0 !important;
              "
            />
            <p class="label ml-1">{{ $t("automated") }}</p>
          </v-col>
        </div>
      </div>
    </v-row>
    <v-row>
      <v-col cols="2" class="col-card">
        <v-card
          class="adding-card-collapsed d-flex align-center justify-start main-card"
          elevation="0"
          @click="showNewBrokerWindow"
        >
          <div class="d-flex justify-center ml-3">
            <v-icon class="plus-icon" small>fa-plus</v-icon>
            <h3 class="ml-2 mt-1" style="font-size: 17px">
              {{ $t("addBrokerAcc") }}
            </h3>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null && adIndex === 1" :ad="ad" />
      <v-col
        v-for="(acc, index) in brokerAccounts"
        v-bind:key="acc.id"
        style="height: 100%"
        v-show="index < 4"
        cols="2"
         class="col-card"
      >
        <v-card
          @mouseenter="hoverAcc = acc.id"
          @mouseleave="hoverAcc = -1"
          class="overall-card-collapsed broker-card main-card"
          outlined
          style="position: relative"
        >
          <v-card-title
            v-if="hoverAcc === acc.id"
            class="mt-n16 justify-end card-header"
            style="
              position: absolute;
              right: 0;
              top: 35px;
              display: flex;
              flex-direction: row;
              width: 100px;
            "
          >
          </v-card-title>
          <v-card-text :class="'pa-3 align-center'" style="height: 100%">
            <v-row class="d-flex justify-between mt-2" style="padding: 0 10px">
              <div class="d-flex">
                <div>
                  <img
                    v-if="acc.verified"
                    src="@/assets/icons/Audited.svg"
                    alt="Audited Icon"
                    class="mr-2"
                    style="width: 15px; height: 15px; margin: 0"
                  />
                  <img
                    v-else
                    src="@/assets/icons/noAudited.svg"
                    alt="No Audited Icon"
                    class="mr-2"
                    style="width: 15px; height: 15px; margin: 0"
                  />
                </div>
                <div>
                  <img
                    v-if="acc.automated"
                    src="@/assets/icons/AutoSync.svg"
                    alt="Auto Sync Icon"
                    class="mr-2"
                    style="width: 15px; height: 15px; margin: 0"
                  />
                  <img
                    v-else
                    src="@/assets/icons/noauto-sync.svg"
                    alt="No Auto Sync Icon"
                    class="mr-2"
                    style="width: 15px; height: 15px; margin: 0"
                  />
                </div>
              </div>
              <div
                v-if="hoverAcc === acc.id"
                class="d-flex align-items-center ml-auto"
              >
                <v-icon class="icon ml-12" @click="editBroker(acc)" small
                  >fa-pen</v-icon
                >
                <v-icon class="icon ml-3" @click="deleteBroker(acc)" small
                  >fa-trash</v-icon
                >
              </div>
            </v-row>
            <v-col class="main-body" @click="editBroker(acc)">
              <h3 class="head mb-2">
                <strong>{{ acc.identifier }}</strong>
              </h3>
              <p class="content">{{ acc.broker.name }}</p>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        v-if="this.$store.state.user.brokerAccounts.length > 5"
        cols="2"
         class="col-card"
      >
        <v-card
          class="see-more-card-collapsed d-flex align-center justify-center main-card"
          elevation="0"
          @click="overlaySeeAllBrokerAcc = true"
        >
          <div class="d-flex justify-center">
            <h3
              class="mr-2"
              style="font-size: 17px; text-decoration-line: underline"
            >
              {{
                $t("seeXMore", {
                  number: this.$store.state.user.brokerAccounts.length - 4,
                })
              }}
            </h3>
            <v-icon small>fa-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-divider class="mt-6 mb-8" />
    <h3 class="mt-3 mb-3 ml-4">
      {{ $t("watchlistAssociatedAssets", { watchlist: $t("watchlist") }) }}
    </h3>
    <v-row>
      <v-col class="col-card" cols="2">
        <v-card
          class="adding-card-collapsed d-flex align-center justify-start main-card"
          elevation="0"
          @click="showNewAssetWindow"
        >
          <div class="d-flex justify-center ml-3">
            <v-icon class="plus-icon" small>fa-plus</v-icon>
            <h3 class="ml-2 mt-1" style="font-size: 17px">
              {{ $t("addAsset") }}
            </h3>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null && adIndex === 1" :ad="ad" />
      <v-col v-for="asset in assets" v-bind:key="asset.ticker" cols="2" class="col-card">
        <v-card
          @mouseenter="hoverAsset = asset.id"
          @mouseleave="hoverAsset = -1"
          class="overall-card-collapsed main-card"
          outlined
        >
          <v-card-title
            v-if="hoverAsset === asset.id"
            class="mt-n16 justify-end card-header"
            style="
              position: absolute;
              right: 0;
              top: 35px;
              display: flex;
              flex-direction: row;
              width: 100px;
            "
          >
          </v-card-title>
          <v-card-text :class="'pa-3 d-flex flex-column'" style="height: 100%">
            <v-row
              v-if="asset.market !== null"
              class="d-flex justify-between align-center"
              style="padding: 0 10px"
            >
              <div class="d-flex">
                <v-chip
                  v-if="asset.market !== null"
                  class="mt-2"
                  small
                  >{{ asset.market.name }}</v-chip
                >
              </div>
              <v-icon
                class="icon icon-chip"
                v-if="hoverAsset === asset.id"
                @click="deleteAsset(asset)"
                small
                >fa-trash</v-icon
              >
            </v-row>
            <v-col class="main-body">
              <h3 class="head mb-2">
                <strong>{{ truncateString(asset.ticker, 15) }}</strong>
              </h3>
              <p class="content">{{ truncateString(asset.assetName, 25) }}</p>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="this.$store.state.user.assets.length > 5" cols="2"  class="col-card">
        <v-card
          class="see-more-card-collapsed d-flex align-center justify-center main-card"
          elevation="0"
          @click="overlaySeeAllAssets = true"
        >
          <div class="d-flex justify-center">
            <h3
              class="mr-2"
              style="font-size: 17px; text-decoration-line: underline"
            >
              {{
                $t("seeXMore", {
                  number: this.$store.state.user.assets.length - 4,
                })
              }}
            </h3>
            <v-icon small>fa-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="mt-6 mb-8" />

    <h3 class="mt-3 mb-3 ml-4">
      {{ $t("watchlistStrategies", { watchlist: $t("watchlist") }) }}
    </h3>
    <v-row>
      <v-col cols="2" class="col-card">
        <v-card
          class="adding-card-collapsed d-flex align-center justify-start main-card"
          elevation="0"
          @click="showNewStrategyWindow"
        >
          <div class="d-flex justify-center ml-3">
            <v-icon class="plus-icon" small>fa-plus</v-icon>
            <h3 class="ml-2 mt-1" style="font-size: 17px">
              {{ $t("addStrategy") }}
            </h3>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null && adIndex === 2" :ad="ad" />
      <v-col v-for="strategy in strategies" v-bind:key="strategy.id" cols="2" class="col-card">
        <v-card
          @mouseenter="hoverStrategy = strategy.id"
          @mouseleave="hoverStrategy = -1"
          class="overall-card-collapsed main-card"
          outlined
          style="padding: 12px"
        >
          <v-card-title
            v-if="hoverStrategy === strategy.id"
            class="mt-n16 justify-end card-header"
            style="
              position: absolute;
              right: 13px;
              top: 70px;
              display: flex;
              flex-direction: row;
              width: 100px;
            "
          >
            <v-icon
              class="icon"
              @click="showDeleteStrategyWindow(strategy)"
              small
              >fa-trash</v-icon
            >
          </v-card-title>
          <v-card-text :class="'pa-3 align-center d-flex'" style="height: 100%">
            <div class="d-flex flex-column m-auto">
              <h3 class="head mb-3">
                <strong>{{ truncateString(strategy.name, 15) }}</strong>
              </h3>
              <p class="content">
                {{ truncateString(strategy.description, 25) }}
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="this.$store.state.user.strategies.length > 5" cols="2" class="col-card">
        <v-card
          class="see-more-card-collapsed d-flex align-center justify-center main-card"
          elevation="0"
          @click="overlaySeeAllStrategies = true"
        >
          <div class="d-flex justify-center">
            <h3
              class="mr-2"
              style="font-size: 17px; text-decoration-line: underline"
            >
              {{
                $t("seeXMore", {
                  number: this.$store.state.user.strategies.length - 4,
                })
              }}
            </h3>
            <v-icon small>fa-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="mt-6 mb-8" />

    <v-row class="d-flex justify-space-between" style="padding-right: 20px">
      <h3 class="mt-3 mb-3 ml-4">
        {{ $t("watchlistHitsMistakes", { watchlist: $t("watchlist") }) }}
      </h3>
      <div class="legend-component">
        <div class="legend-container">
          <v-col class="d-flex icons-container">
            <v-icon
              color="green"
              class="mr-2"
              style="font-size: 15px !important; margin: 0 !important"
              >fa-check-circle</v-icon
            ><p class="label mr-4 ml-1">{{ $t("considerations.hit") }}</p>
            <v-icon
              color="#f14400"
              class="mr-2"
              style="font-size: 15px !important; margin: 0 !important"
              >fa-times-circle</v-icon
            ><p class="label mr-4 ml-1">{{ $t("considerations.mistake") }}</p>
            <v-icon
              color="#3b3b3b"
              class="mr-2"
              style="font-size: 15px !important; margin: 0 !important"
              >fa-stop-circle</v-icon
            ><p class="label mr-4 ml-1">{{ $t("considerations.other") }}</p>
          </v-col>
        </div>
      </div>
    </v-row>
    <v-row>
      <v-col cols="2" class="col-card">
        <v-card
          class="adding-card-collapsed d-flex align-center justify-start main-card"
          elevation="0"
          @click="showNewConsiderationWindow"
        >
          <div class="d-flex justify-center ml-3">
            <v-icon class="plus-icon" small>fa-plus</v-icon>
            <h3 class="ml-2 mt-1" style="font-size: 17px">
              {{ $t("addHitMistake") }}
            </h3>
          </div>
        </v-card>
      </v-col>
      <SingleCardAd v-if="ad !== null && adIndex === 3" :ad="ad" />
      <v-col
        v-for="consideration in considerations"
        v-bind:key="consideration.id"
        cols="2"
        class="col-card"
      >
        <v-card
          @mouseenter="hoverConsideration = consideration.id"
          @mouseleave="hoverConsideration = -1"
          class="overall-card-collapsed main-card"
          outlined
        >
          <v-card-title
            v-if="hoverConsideration === consideration.id"
            class="mt-n16 justify-end card-header"
            style="
              position: absolute;
              right: 13px;
              top: 70px;
              display: flex;
              flex-direction: row;
              width: 100px;
            "
          >
            <v-icon
              class="icon"
              @click="deleteConsideration(consideration)"
              small
              >fa-trash</v-icon
            >
          </v-card-title>
          <v-card-text
            :class="'pa-3 align-center d-flex flex-column'"
            style="height: 100%"
          >
            <v-icon
              v-if="consideration.type !== null"
              :color="getConsiderationColor(consideration)"
              class="d-flex mr-auto mt-2"
              small
              style="margin-left: 12px"
              >{{ getConsiderationIcon(consideration) }}</v-icon
            >
            <v-col class="main-body">
              <h3 class="head" style="font-size: 20px">
                <strong> {{ truncateString(consideration.name, 15) }}</strong>
              </h3>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        v-if="this.$store.state.user.considerations.length > 5"
        cols="2"
        class="col-card"
      >
        <v-card
          class="see-more-card-collapsed d-flex align-center justify-center main-card"
          elevation="0"
          @click="overlaySeeAllConsiderations = true"
        >
          <div class="d-flex justify-center">
            <h3
              class="mr-2"
              style="font-size: 17px; text-decoration-line: underline"
            >
              {{
                $t("seeXMore", {
                  number: this.$store.state.user.considerations.length - 4,
                })
              }}
            </h3>
            <v-icon small>fa-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay :dark="false" :value="overlaySeeAllAssets">
      <SeeAllAssets
        @closeWindow="overlaySeeAllAssets = false"
        @removeAsset="deleteAsset"
      />
    </v-overlay>
    <v-overlay :dark="false" :value="overlayAddAsset">
      <AddAsset @closeWindow="overlayAddAsset = false" />
    </v-overlay>
    <v-overlay :dark="false" :value="overlayDeleteAsset">
      <DeleteAsset
        @closeDeleteWindow="overlayDeleteAsset = false"
        :asset="assetToBeDeleted"
      />
    </v-overlay>
    <v-overlay :dark="false" :value="overlaySeeAllStrategies">
      <SeeAllStrategies
        @closeWindow="overlaySeeAllStrategies = false"
        @removeStrategy="showDeleteStrategyWindow"
      />
    </v-overlay>
    <v-overlay :dark="false" :value="overlayNewStrategy">
      <AddStrategy @closeWindow="overlayNewStrategy = false" />
    </v-overlay>
    <v-overlay :dark="false" :value="overlayDeleteStrategy">
      <DeleteStrategy
        :strategy="strategyToDelete"
        @closeDeleteWindow="overlayDeleteStrategy = false"
      />
    </v-overlay>
    <v-overlay :dark="false" :value="overlaySeeAllConsiderations">
      <SeeAllConsiderations
        @closeWindow="overlaySeeAllConsiderations = false"
        @removeConsideration="deleteConsideration"
      />
    </v-overlay>
    <v-overlay :dark="false" :value="overlayAddConsideration">
      <AddConsideration @closeWindow="overlayAddConsideration = false" />
    </v-overlay>
    <v-overlay :dark="false" :value="overlayDeleteConsideration">
      <DeleteConsideration
        :consideration="considerationToBeDeleted"
        @closeWindow="overlayDeleteConsideration = false"
      />
    </v-overlay>

    <!-- Overlay for Upgrade to Pro!-->
    <v-overlay :dark="false" v-model="dialogUpgradeToPro">
      <UpgradeToPro
        :message="messageUpgradeToPro"
        @closeWindow="dialogUpgradeToPro = false"
      />
    </v-overlay>
    <v-overlay
      :dark="false"
      class="overlay-data-table"
      v-model="overlaySeeAllBrokerAcc"
    >
      <div class="data-table-container">
        <div class="dt-header">
          <v-icon class="icon close-btn" @click="overlaySeeAllBrokerAcc = false"
            >fa-times-circle</v-icon
          >
        </div>
        <v-data-table
          :headers="brokerAccountsTableHeaders"
          :items="this.$store.state.user.brokerAccounts"
          class="brokerAcc-data-table"
        >
          <template v-slot:item.broker.name="{ item }">
            <p class="my-0" style="font-size: 14px">
              {{ item.broker.name }}
              <v-chip
                v-if="
                  brokersWithMT4IntegrationIds.findIndex(
                    (value) => value === item.broker.id
                  ) !== -1
                "
                class="ml-2"
                small
                @click="linkMetaTrader(item)"
              >
                <span style="font-size: 14px">{{
                  $t("brokerModule.linkMetaTraderBtn")
                }}</span>
                <v-icon class="icon ml-2" color="black" x-small
                  >fa-laptop</v-icon
                >
              </v-chip>
            </p>
          </template>
          <template v-slot:item.type="{ item }">
            <p class="my-0" style="font-size: 14px">
              {{ `${item.type} (${item.currency})` }}
            </p>
          </template>
          <template v-slot:item.automated="{ item }">
            <img
              v-if="item.automated"
              src="@/assets/icons/AutoSync.svg"
              alt="AutoSync Icon"
              class="mr-1"
              style="width: 16px; height: 16px; color: green"
            />
            <p v-else class="my-0" style="font-size: 14px">No</p>
          </template>
          <template v-slot:item.verified="{ item }">
            <img
              v-if="item.verified"
              src="@/assets/icons/Audited.svg"
              alt="Audited Icon"
              class="mr-1"
              style="width: 16px; height: 16px; color: blue"
            />
            <v-chip
              v-else-if="item.automated"
              small
              @click="verifyBrokerAccount(item)"
            >
              <span style="font-size: 14px">{{
                $t("brokerModule.tableVerifyNow")
              }}</span>
              <img
                src="@/assets/icons/noAudited.svg"
                alt="Audited Icon"
                class="icon ml-2"
                style="width: 16px; height: 16px; color: black"
              />
            </v-chip>
            <p v-else class="my-0" style="font-size: 14px">No</p>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="icon-container">
              <v-icon
                class="mr-3 icon"
                small
                @click="
                  (brokerAccToBeDeleted = item) &&
                    (overlayEditBrokerAccount = true)
                "
                >fa-pen</v-icon
              >
              <v-icon
                v-if="!item.verified"
                class="icon"
                small
                @click="deleteBroker(item)"
                >fa-trash</v-icon
              >
            </div>
          </template>
        </v-data-table>
      </div>
    </v-overlay>
    <v-overlay :dark="false" v-model="overlayAddBrokerAcc">
      <AddBrokerAccount @closeWindow="() => (overlayAddBrokerAcc = false)" />
    </v-overlay>

    <v-overlay :dark="false" v-model="overlayDeleteBrokerAcc">
      <DeleteBrokerAccount
        :brokerAccount="brokerAccToBeDeleted"
        @closeWindow="() => (overlayDeleteBrokerAcc = false)"
      />
    </v-overlay>
    <v-overlay :dark="false" v-model="overlayEditBrokerAccount">
      <EditBrokerAccount
        :brokerAccount="brokerAccToBeDeleted"
        @closeWindow="overlayEditBrokerAccount = false"
      />
    </v-overlay>
    <v-overlay :dark="false" v-model="overlayVerifyBrokerAccount">
      <VerifyBrokerAccount
        :broker-account="brokerAccToBeDeleted"
        @closeWindow="overlayVerifyBrokerAccount = false"
      />
    </v-overlay>
  </v-container>
</template>

<script>
import AdEngine from "../../ads/adEngine";

import AddStrategy from "./AddStrategy";
import { mapMutations } from "vuex";
import DeleteStrategy from "./DeleteStrategy";
import ProLimits from "../../proLimits";
import UpgradeToPro from "../../components/UpgradeToPro";
import DeleteAsset from "@/views/Asset/DeleteAsset";
import AddAsset from "@/views/Asset/AddAsset";
import AddConsideration from "@/views/Consideration/components/AddConsideration";
import DeleteConsideration from "@/views/Consideration/components/DeleteConsideration";
import SeeAllAssets from "@/views/Asset/SeeAllAssets";
import SeeAllStrategies from "@/views/Watchlist/SeeAllStrategies";
import SeeAllConsiderations from "@/views/Consideration/components/SeeAllConsiderations";
import SingleCardAd from "@/ads/SingleCardAd";
import AddBrokerAccount from "../User/views/AddBrokerAccount";
import DeleteBrokerAccount from "../User/views/DeleteBrokerAccount";
import EditBrokerAccount from "../User/views/EditBrokerAccount";
import VerifyBrokerAccount from "../User/views/VerifyBrokerAccount";

export default {
  name: "Watchlist",
  components: {
    SingleCardAd,
    SeeAllConsiderations,
    SeeAllStrategies,
    SeeAllAssets,
    DeleteConsideration,
    AddConsideration,
    AddAsset,
    DeleteAsset,
    UpgradeToPro,
    DeleteStrategy,
    AddStrategy,
    AddBrokerAccount,
    DeleteBrokerAccount,
    EditBrokerAccount,
    VerifyBrokerAccount,
  },
  data() {
    return {
      // Ads
      ad: null,
      adIndex: 0,

      hoverStrategy: -1,
      strategies: this.$store.state.user.strategies,
      overlaySeeAllStrategies: false,
      overlayNewStrategy: false,
      overlayDeleteStrategy: false,
      strategyToDelete: null,
      brokerAccounts: null,

      hoverAsset: -1,
      assets: this.$store.state.user.assets,
      overlaySeeAllAssets: false,
      overlayAddAsset: false,
      overlayDeleteAsset: false,
      assetToBeDeleted: null,

      hoverConsideration: -1,
      hoverAcc: -1,
      considerations: this.$store.state.user.considerations,
      overlaySeeAllConsiderations: false,
      overlayAddConsideration: false,
      overlayEditConsideration: false,
      overlayDeleteConsideration: false,
      considerationToBeDeleted: false,
      brokerAccToBeDeleted: null,
      overlayDeleteBrokerAcc: false,
      // Upgrade to pro
      messageUpgradeToPro: this.$t("messageUpgradeToPro"),
      dialogUpgradeToPro: false,
      overlayAddBrokerAcc: false,
      overlaySeeAllBrokerAcc: false,
      brokerAccountsTableHeaders: [],
      brokersWithMT4IntegrationIds: [316, 308],
      overlayEditBrokerAccount: false,
      overlayVerifyBrokerAccount: false,
      acc: {
        verified: false,
        automated: false,
      },
    };
  },
  watch: {
    "$store.state.user.assets": function () {
      this.init();
    },
    "$store.state.user.strategies": function () {
      this.init();
    },
    "$store.state.user.considerations": function () {
      this.init();
    },
  },
  computed: {
    nonNone(strategy) {
      return strategy !== "None";
    },
  },
  mounted() {
    this.validateAuthenticated();
    this.init();
    this.getTable();
    this.setCardsHeight();
  },
  methods: {
    validateAuthenticated() {
      if (this.$store.state.token === "") this.$router.push("/");
    },
    getTable() {
      this.brokerAccountsTableHeaders = [
        { text: this.$t("brokerModule.tableBrokerName"), value: "broker.name" },
        { text: this.$t("brokerModule.tableAccountId"), value: "identifier" },
        { text: this.$t("brokerModule.tableAccountType"), value: "type" },
        {
          text: this.$t("brokerModule.tableAutomated"),
          value: "automated",
          sortable: false,
        },
        {
          text: this.$t("brokerModule.tableVerified"),
          value: "verified",
          sortable: false,
        },
        {
          text: this.$t("brokerModule.tableActions"),
          value: "action",
          sortable: false,
        },
      ];
    },
    setCardsHeight() {
      setTimeout(function () {
        let highestHeight = 0;
        document.querySelectorAll(".main-card").forEach(function (card) {
          if (card.offsetHeight > highestHeight)
            highestHeight = card.offsetHeight;
        });
        // eslint-disable-next-line no-console
        console.log(highestHeight);
        document.querySelectorAll(".main-card").forEach(function (card) {
          card.style.height = highestHeight + "px";
          // eslint-disable-next-line no-console
          console.log(card.style.height);
        });
      }, 0);
    },
    retrieveAd() {
      this.ad = AdEngine.getRandomAd("Small Ad");
      this.adIndex = Math.floor(Math.random() * 3) + 1;
    },
    ...mapMutations(["setStrategies"]),
    init() {
      this.retrieveAd();
      //if (this.$store.state.user.strategies.length === 0)
      //  this.overlayNewStrategy = true;
      this.assets =
        this.$store.state.user.assets.length > 5 && this.adIndex === 1
          ? this.$store.state.user.assets.slice(0, 3)
          : this.$store.state.user.assets.length > 5
          ? this.$store.state.user.assets.slice(0, 4)
          : this.$store.state.user.assets;

      this.strategies =
        this.$store.state.user.strategies.length > 5 && this.adIndex === 2
          ? this.$store.state.user.strategies.slice(0, 3)
          : this.$store.state.user.strategies.length > 5
          ? this.$store.state.user.strategies.slice(0, 4)
          : this.$store.state.user.strategies;

      this.considerations =
        this.$store.state.user.considerations.length > 5 && this.adIndex === 3
          ? this.$store.state.user.considerations.slice(0, 3)
          : this.$store.state.user.considerations.length > 5
          ? this.$store.state.user.considerations.slice(0, 4)
          : this.$store.state.user.considerations;
      this.brokerAccounts = this.$store.state.user.brokerAccounts;
      // eslint-disable-next-line no-console
      console.log(this.brokerAccounts);
    },
    getConsiderationName(consideration) {
      let considerationType = consideration.type;
      return considerationType === "HIT"
        ? this.$t("considerations.hit")
        : considerationType === "MISTAKE"
        ? this.$t("considerations.mistake")
        : this.$t("considerations.other");
    },
    getConsiderationColor(consideration) {
      let considerationType = consideration.type;
      return considerationType === "HIT"
        ? "var(--v-darkGreen-base)"
        : considerationType === "MISTAKE"
        ? "#f14400"
        : "#3b3b3b";
    },
    getConsiderationIcon(consideration) {
      let considerationType = consideration.type;
      return considerationType === "HIT"
        ? "fa-check-circle"
        : considerationType === "MISTAKE"
        ? "fa-times-circle"
        : "fa-stop-circle";
    },
    strategyMonitor() {
      /*this.$router.push({
          name: 'strategy-overview',
          params: {asset: strategy},
      })*/
    },
    showNewAssetWindow() {
      if (
        this.$store.state.user.isPro ||
        ProLimits.verifyLimitsByAssetsInWatchlist(
          this.$store.state.user.assets.length
        )
      )
        this.overlayAddAsset = true;
      else this.dialogUpgradeToPro = true;
    },
    assetOverview(tickerSelected) {
      let foundAsset = this.assets.find((asset) => {
        return asset.ticker === tickerSelected;
      });
      this.$router.push({
        name: "asset-overview",
        params: { asset: foundAsset },
      });
    },
    deleteAsset(asset) {
      this.assetToBeDeleted = asset;
      this.overlayDeleteAsset = true;
    },
    showNewBrokerWindow() {
      this.overlayAddBrokerAcc = true;
    },
    deleteBroker(acc) {
      this.brokerAccToBeDeleted = acc;
      this.overlayDeleteBrokerAcc = true;
    },
    editBroker(acc) {
      this.brokerAccToBeDeleted = acc;
      this.overlayEditBrokerAccount = true;
    },
    showNewStrategyWindow() {
      if (
        this.$store.state.user.isPro ||
        ProLimits.verifyLimitsByStrategies(
          this.$store.state.user.strategies.length
        )
      )
        this.overlayNewStrategy = true;
      else this.dialogUpgradeToPro = true;
    },
    showDeleteStrategyWindow(strategy) {
      this.strategyToDelete = strategy;
      this.overlayDeleteStrategy = true;
    },
    showNewConsiderationWindow() {
      if (
        this.$store.state.user.isPro ||
        ProLimits.verifyLimitsByConsiderations(
          this.$store.state.user.considerations.length
        )
      )
        this.overlayAddConsideration = true;
      else this.overlayUpgradeToPro = true;
    },
    deleteConsideration(consideration) {
      this.considerationToBeDeleted = consideration;
      this.overlayDeleteConsideration = true;
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
    truncateString(string, maxLength) {
      return string !== null && string.length > maxLength
        ? `${string.substring(0, maxLength)}...`
        : string;
    },
    verifyBrokerAccount(brokerAccount) {
      this.brokerAccToBeDeleted = brokerAccount;
      this.overlayVerifyBrokerAccount = true;
    },
  },
};
</script>

<style lang="scss">
@import "../../global";

.v-col.col-card {
  min-width: 240px !important;
}

.watchlist-container {
  .main-card {
    width: 100% !important;
    height: 100%;
  }

  .card-header {
    .v-icon {
      font-size: 18px;
      margin: 0 5px;
    }
  }

  .chip-container {
    padding: 5px;
  }

  .brokerAcc-data-table {
    background: var(--v-mainWhite-base);
    padding: 30px;
    max-height: 70vh;
    overflow-y: auto;
  }

  .broker-card .main-body {
    cursor: pointer;
    padding: 0 10px 5px 10px;
  }
  .legend-component {
    .legend-container {
      .icons-container {
        .legend-text {
          margin-left: 5px;
          margin-right: 10px;
          font-size: 13px;
        }
      }
    }
  }
  .icon-container {
    display: flex;
    align-items: center;
  }

  .icon {
    cursor: pointer;
    margin-right: 5px; /* Ajusta este valor según sea necesario */
  }

  .icon:last-child {
    margin-right: 0; /* Elimina el margen derecho del último icono */
  }
  .data-table-container {
    background: var(--v-mainWhite-base);
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    padding: 20px;

    .dt-header {
      display: flex;
      justify-content: flex-end;
    }

    box-shadow: 0px 0px 5px 0px var(--v-mainBlack-base);
  }
  .plus-icon {
    width: 30px !important;
    height: 30px !important;
  }
  .v-chip-custom {
    background: var(--v-alternativeBtnBackground-base) !important;
  }

  .v-chip-custom .v-chip__content {
    color: var(--v-darkGrey-base) !important;
  }
  .v-icon.icon-chip {
    cursor: pointer;
    margin-left: auto;
  }
  .title-2 {
    font-weight: 700;
    font-family: "Avenir", sans-serif;
    margin: 0;
    padding-left: 0;
    padding-right: 0;
    color: var(--v-darkGrey-base);

    @media (max-width: 768px) {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
